import React, { useEffect, useState } from 'react'
import ReactApexChart from "react-apexcharts";
import { triangle } from '../../Images/Icons';

const ChartSection = (props) => {



    const [state, setNewState] = useState({
        series: [{
            name: 'PV output',
            color: '#0FC637',
            data: props.from_pv
        }, {
            name: 'Total consumption',
            color:'#F66453',
            data: props.total_consumption,
            hidden: true
        }, {
            name: 'Consumed from PV',
            color:'#3698FF',
            data: [null, null,null]
        }, {
            name: 'Battery (charge)',
            color:'#D090D6',
            data: props.battery_charge
        }, {
            name: 'Battery (discharge)',
            color:'#FC891F',
            data: props.battery_discharge
        }],
        options: {
            chart: {
                height: 800,
                type:  'area'
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth'
            },
            xaxis: {
                type: 'int',
                categories: props.legend,
                range: 6 

            },
            tooltip: {
                x: {
                    format: 'dd/MM/yy HH:mm'
                },
            }, yaxis: {
                labels: {
                  formatter: function (value) {
                    return value.toFixed(0); // Format y-axis labels as integers
                  }
                }
            },animations: {
              enabled: false // Disable animations for large datasets
            }

        },
        showPopupConsumption: false
    });
    
    const showPopupConsumption = () => {
        setNewState({ showPoup: true });
        setTimeout(() => {
            setNewState({ showPoup: false });
        }, 3000);
    }
    

    const { series, options, showPoup } = state;
    
    
    useEffect(() => {
        
        setNewState({
            series: [{
                name: props.selectedTab == 0 ? 'PV output' : 'Yield',
                color: '#0FC637',
                data: props.from_pv
            }, {
                name: props.selectedTab == 0 ? 'Total consumption' : 'Consumption',
                color:'#F66453',
                data: props.total_consumption
            }, {
                name: 'Consumed from PV',
                color:'#3698FF',
                data:  props.from_pv 
            }, {
                name: 'Battery (charge)',
                color:'#D090D6',
                data: props.battery_charge
            }, {
                name: 'Battery (discharge)',
                color:'#FC891F',
                data: props.battery_discharge
            }],
            options: {
                chart: {
                    height: 350,
                    type:  'area',
                    zoom: {
                      enabled: true,
                      type: 'x',
                      autoScaleYaxis: true
                    },
                    toolbar: {
                      autoSelected: 'zoom'
                    }
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    curve: 'smooth'
                },
                
                stacked: true,
                xaxis: {
                    type: 'int',
                    categories: props.legend,
                    range: 5
                    
                },
                tooltip: {
                    x: {
                        format: 'dd/MM/yy HH:mm'
                    },
                },
    
            },
        });
    }, [props.from_pv, props.total_consumption, props.battery_charge]); // Dependencies array, update state when these props change


    return (
        <div style={{position:'relative'}}> 
            <div style={{ height: 20,position:'absolute', marginTop: 26,fontSize: 12, fontWeight: 500, color: '#5E677B', right:0, marginBottom:10 }}>
                <span onClick={showPopupConsumption} className='fi fi-rr-info' style={{ marginLeft: 4, lineHeight: 0.8, fontSize: 14, cursor: 'pointer' }}></span>
            </div>
            <div style={{width: '10%',height:30, top:21,zIndex:99, position:'relative',background:'#fff', fontSize:'12px',color:'#7B7E87', paddingLeft:10, paddingTop:10}}>kW</div>
            
            <div style={{ marginTop: 0,position:'relative', top:40, zIndex:100, display: 'flex', justifyContent: 'end' }}>


            </div>
            <div id="chart-area" style={{marginTop: 12}}>
                <ReactApexChart options={options} series={series} type="area" height={280} />
            </div>
            
            {/**Tooltip */}
            {showPoup && <>
                <div style={{
                    width: 300, height: 40, position: 'absolute', top: 55, right: -24, background: '#2C313A', borderRadius: 12, zIndex: 1000,
                    fontSize: 12, fontWeight: 400, color: '#FAFAFA', padding: 12
                }}>
                    The data system updates every hour.
                </div>
                <div style={{ position: 'absolute', top: 40, right: -12 }}><img src={triangle} alt="" style={{ width: 36, height: 24 }} /></div>
            </>}
        </div>
    )
}

export default ChartSection